// 各模块间通用的请求接口
import httpRequest from '../utils/request'

let baseURLV2 = '/api/v2'
let baseURLCommonV2 = 'Common/api/v2/'

/**
 * 请求仓库列表
 * @param {Object} data 分页数据，分页查询。默认是查询全部数据
 */
export function getWarehouses (data) {
  let sendData = data || {
    Pagination: 1,
    PageSize: 1000
  }
  return httpRequest.fetchPost(`${baseURLV2}/GetWarehouses`, sendData)
}

/**
 * 请求面单上传OSS token
 * @param {Object} data 上传文件信息
 */
export function getOSSToken (data) {
  return httpRequest.fetchPost(`${baseURLCommonV2}/GetOssPolicyTokenForLabel`, data)
}

/**
 * 请求账户余额信息
 */
export function getAccountRequest () {
  return httpRequest.fetchPost(`${baseURLV2}/GetAccountBalances`)
}



// WEBPACK FOOTER //
// ./src/api/common.js